/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2021-01-07 14:45:40
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\service\trsUploadAudioVedioNew\directive\trsPlayAudioVideo.js
 * @Description: '
 */
/**
 * “用于详情页正文中有音视频，点击音视频图片后，自动弹出预览音视频弹窗的” 的指令
 * Bai.zhiming
 */
'use strict';
angular.module('trsPlayAudioVideoModule', []).directive('trsPlayAudioVideo', [
    'editCenUploadVideoForXjService',
    function(editCenUploadVideoForXjService) {
        return {
            restrict: 'A',
            replace: false,
            scope: false,
            link: function(scope, $elem) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $elem.delegate('img[videoid]', 'click', function(event) {
                        replaceAudioVideo($(event.target), '视频');
                    });
                    $elem.delegate('img[audioid]', 'click', function(event) {
                        replaceAudioVideo($(event.target), '音频');
                    });
                }

                /**
                 * [replaceAudioVideo description] 将图片播放转换为音频或者提示语
                 * @param   {[object]}  target  [target description] 图片节点
                 * @return  {[undefined]}       [return description]
                 */
                function replaceAudioVideo(target){
                    var videoid = target.attr('videoid');
                    editCenUploadVideoForXjService.getVideoMark(videoid).then(function(data) {
                        var status = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                        if (status === '转码完成'){
                            var video = '<video src="' + data.videoUrl + '" controls="controls" style="width:550px" autoplay="autoplay"></video>';
                            target.after(video);
                            target.remove();
                        } else {
                            target.parent().css('position', 'relative');
                            target.after('<div>尚未转码完成，暂不支持播放</div>');
                            target.next().css({
                                position: 'absolute',
                                left: target[0].offsetLeft,
                                top: target[0].offsetTop,
                                width: target.width(),
                                height: target.height(),
                                background: '#000c',
                                zIndex: 900,
                                textAlign: 'center',
                                color: '#fff',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                lineHeight: Math.ceil(target.height()) + 'px',
                            });
                        }
                    });
                }
            },
        };
    },
]);
